module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-5.dfd02bcc.jpg";